module.exports = __webpack_public_path__ + "static/img/4.d226ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/4.png
// module id = obuh
// module chunks = 0